import React, { Component, useState } from "react";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { NavLink } from "react-router-dom";

import { observer, inject } from "mobx-react";
import appRoutes from "../utils/appRoutes";

const CollapsibleSection = ({ title, children, initiallyOpen = false }) => {
  const [open, setOpen] = useState(initiallyOpen);
  return (
    <>
      <ListItemButton onClick={() => setOpen(!open)} sx={{ color: "white" }}>
        <ListItemText primary={title} />
        {open ? <ExpandLess sx={{ color: "white" }} /> : <ExpandMore sx={{ color: "white" }} />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
};

const SuperAdmin = () => {
  return (
    <List className="app-left-menu">
      <CollapsibleSection title="Accounts" initiallyOpen={true}>
        <NavLink key="acc-1" className="app-left-menu-link level-2" to="/teachers">Teachers</NavLink>
        <NavLink key="acc-2" className="app-left-menu-link level-2" to="/newchild">Add Child</NavLink>
        <NavLink key="acc-3" className="app-left-menu-link level-2" to="/parents">Parents</NavLink>
        <NavLink key="acc-4" className="app-left-menu-link level-3" to="/contact-list">Contact list</NavLink>
        <NavLink key="acc-5" className="app-left-menu-link level-2" to="/children">Children</NavLink>
        <NavLink key="acc-6" className="app-left-menu-link level-3" to={appRoutes.allChildren}>All Children</NavLink>
        <NavLink key="acc-7" className="app-left-menu-link level-2" to="/dob">DOB</NavLink>
        <NavLink key="acc-8" className="app-left-menu-link level-2" to={appRoutes.vaccineRecords}>Medical Records</NavLink>
      </CollapsibleSection>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
      <NavLink className="app-left-menu-link" to="/organisations">Schools</NavLink>
      <NavLink className="app-left-menu-link" to="/classes">Classes</NavLink>
      <NavLink className="app-left-menu-link" to="/class-rosters">Class Rosters</NavLink>
      <NavLink className="app-left-menu-link" to="/attendance">Attendance Tracker</NavLink>
      <NavLink className="app-left-menu-link" to="/admins">Managers</NavLink>
      <NavLink className="app-left-menu-link" to={appRoutes.actionLogs}>Logs</NavLink>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
      <CollapsibleSection title="Finance" initiallyOpen={false}>
        <NavLink key="fin-1" className="app-left-menu-link level-2" to="/programs">Programs</NavLink>
        <NavLink key="fin-2" className="app-left-menu-link level-2" to="/invoices">Invoices</NavLink>
        <NavLink key="fin-3" className="app-left-menu-link level-2" to="/transactions">Transactions</NavLink>
        <NavLink key="fin-4" className="app-left-menu-link level-2" to="/sendarchive">Send Archive</NavLink>
        <NavLink key="fin-5" className="app-left-menu-link level-2" to="/allfeatureinvoices">Future Invoices</NavLink>
        <NavLink key="fin-6" className="app-left-menu-link level-2" to="/dashboard">Financial Charts</NavLink>
        <NavLink key="fin-7" className="app-left-menu-link level-2" to="/schedule">Invoice Schedule</NavLink>
      </CollapsibleSection>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
      <NavLink className="app-left-menu-link" to="/mealmenu">Meal Menu</NavLink>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
      <NavLink className="app-left-menu-link" to="/imex">Import/Export</NavLink>
    </List>
  );
};

const Admin = (props) => {
  const show_finance = props.profile && props.profile.show_finance;
  const show_charts = props.profile && props.profile.show_charts;
  const show_future_invoices = props.profile && props.profile.show_future_invoices;

  const financeItems = [];

  if (show_finance) {
    financeItems.push(<NavLink key="fin-1" className="app-left-menu-link level-2" to="/invoices">Invoices</NavLink>);
    financeItems.push(<NavLink key="fin-2" className="app-left-menu-link level-2" to="/sendarchive">Send Archive</NavLink>);
  }

  if (show_future_invoices) {
    financeItems.push(<NavLink key="fin-3" className="app-left-menu-link level-2" to="/allfeatureinvoices">Future Invoices</NavLink>);
  }

  if (show_charts) {
    financeItems.push(<NavLink key="fin-4" className="app-left-menu-link level-2" to="/dashboard">Financial Charts</NavLink>);
  }

  return (
    <List className="app-left-menu">
      <CollapsibleSection title="Accounts" initiallyOpen={false}>
        <NavLink key="acc-1" className="app-left-menu-link level-2" to="/teachers">Teachers</NavLink>
        <NavLink key="acc-2" className="app-left-menu-link level-2" to="/newchild">Add Child</NavLink>
        <NavLink key="acc-3" className="app-left-menu-link level-2" to="/parents">Parents</NavLink>
        <NavLink key="acc-4" className="app-left-menu-link level-3" to="/contact-list">Contact list</NavLink>
        <NavLink key="acc-5" className="app-left-menu-link level-2" to="/children">Children</NavLink>
        <NavLink key="acc-6" className="app-left-menu-link level-2" to="/dob">DOB</NavLink>
        <NavLink key="acc-7" className="app-left-menu-link level-2" to={appRoutes.vaccineRecords}>Medical Records</NavLink>
      </CollapsibleSection>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
      <NavLink className="app-left-menu-link" to="/classes">Classes</NavLink>
      <NavLink className="app-left-menu-link" to="/class-rosters">Class Rosters</NavLink>
      <NavLink className="app-left-menu-link" to="/attendance">Attendance Tracker</NavLink>
      <NavLink className="app-left-menu-link" to={appRoutes.actionLogs}>Logs</NavLink>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
      {financeItems.length > 0 && (
        <CollapsibleSection title="Finance" initiallyOpen={false}>
          {financeItems}
        </CollapsibleSection>
      )}
      {financeItems.length > 0 && (
        <>
          <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
          <NavLink className="app-left-menu-link" to="/mealmenu">Meal Menu</NavLink>
        </>
      )}
    </List>
  );
};

const Manager = (props) => {
  const show_finance = props.profile && props.profile.show_finance;

  const financeItems = [];

  if (show_finance) {
    financeItems.push(<NavLink key="fin-1" className="app-left-menu-link level-2" to="/invoices">Invoices</NavLink>);
    financeItems.push(<NavLink key="fin-2" className="app-left-menu-link level-2" to="/transactions">Transactions</NavLink>);
    financeItems.push(<NavLink key="fin-3" className="app-left-menu-link level-2" to="/sendarchive">Send Archive</NavLink>);
  }

  return (
    <List className="app-left-menu">
      <CollapsibleSection title="Accounts" initiallyOpen={true}>
        <NavLink key="acc-1" className="app-left-menu-link level-2" to="/newchild">Add Child</NavLink>
        <NavLink key="acc-2" className="app-left-menu-link level-2" to="/parents">Parents</NavLink>
        <NavLink key="acc-3" className="app-left-menu-link level-3" to="/contact-list">Contact list</NavLink>
        <NavLink key="acc-4" className="app-left-menu-link level-2" to="/children">Children</NavLink>
        <NavLink key="acc-5" className="app-left-menu-link level-2" to="/dob">DOB</NavLink>
        <NavLink key="acc-6" className="app-left-menu-link level-2" to={appRoutes.vaccineRecords}>Medical Records</NavLink>
      </CollapsibleSection>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
      <NavLink className="app-left-menu-link" to="/classes">Classes</NavLink>
      <NavLink className="app-left-menu-link" to="/class-rosters">Class Rosters</NavLink>
      <NavLink className="app-left-menu-link" to="/attendance">Attendance Tracker</NavLink>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
      {financeItems.length > 0 && (
        <CollapsibleSection title="Finance" initiallyOpen={false}>
          {financeItems}
        </CollapsibleSection>
      )}
    </List>
  );
};

const Default = () => <List />;

class LeftMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      profile: null,
      role: ""
    };
  }

  static getDerivedStateFromProps(props) {
    return { role: props.Auth.role };
  }

  render() {
    switch (this.state.role) {
      case "superadmin":
        return <SuperAdmin />;
      case "admin":
        return <Admin profile={this.props.Auth.profile} />;
      case "manager":
        return <Manager profile={this.props.Auth.profile} />;
      default:
        return <Default />;
    }
  }
}
export default inject("Auth")(observer(LeftMenu))

